/**
 * Created by YYVZB on 2017/10/17.
 */
let pathObj = {
  javaPath: '',
  wxAppId: '',
  domainName: '',
  webSocketPath: 'ws://danmu.yxvzb.com',
  wxAccount: '',
  env: 'yxvzb'
};
let protocol = location.protocol === 'https:' ? 'https' : 'http'

// (function (){
let locationUrl = location.href
if (/doc\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: `${protocol}://doc.jimijiayuan.cn`,
    wxAppId: 'wx07d0029693e87412',
    domainName: 'doc.jimijiayuan.cn',
    webSocketPath: 'ws://danmu.yxvzb.com',
    wxAccount: 'linchuang119',
    env: 'doc'
  }
} else if (/www\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: `${protocol}://www.jimijiayuan.cn`,
    wxAppId: 'wxf1c4eecc87711456',
    domainName: 'www.jimijiayuan.cn',
    webSocketPath: 'ws://192.168.0.132:8088',
    wxAccount: 'frozenhome'
  }
}
else if(/192\.168\.0/.test(locationUrl)){
  pathObj = {
    javaPath: `${protocol}://www.yxvzb.com`,
    wxAppId: 'wx89dc34dd18c86446',
    domainName: 'www.yxvzb.com',
    webSocketPath: 'ws://danmu.yxvzb.com',
    wxAccount: 'vzb0066'
  }
}else if(/pc2\.jimijiayuan\.cn/.test(locationUrl)){
  pathObj = {
    javaPath: `${protocol}://pc2.jimijiayuan.cn`,
    wxAppId: 'wxe37f12b1fa076c1a',
    domainName: 'pc2.jimijiayuan.cn',
    webSocketPath: 'ws://192.168.0.132:8088',
    wxAccount: 'yiyangkeji_xiaowei'
  }
}
else if (/ysh-wxv2\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: `${protocol}://ysh-wxv2.jimijiayuan.cn`,
    wxAppId: 'wxe37f12b1fa076c1a',
    domainName: 'ysh-wxv2.jimijiayuan.cn',
    webSocketPath: 'ws://192.168.0.105:8383',
    wxAccount: 'yiyangkeji_xiaowei'
  }
}
else if(/sj-wx\.jimijiayuan\.cn/.test(locationUrl)) {
  pathObj = {
    javaPath: `${protocol}://sj-wx.jimijiayuan.cn`,
    wxAppId: 'wx310b45cf0f4ed5b0',
    domainName: 'sj-wx.jimijiayuan.cn',
    webSocketPath: 'ws://192.168.0.105:8383',
    wxAccount: 'yiyangkeji666666',
    env: 'doc'
  }
}
else {
  pathObj = {
    javaPath: `${protocol}://wx.yxvzb.com`,
    wxAppId: 'wx89dc34dd18c86446',
    domainName: 'wx.yxvzb.com',
    webSocketPath: 'ws://danmu.yxvzb.com',
    wxAccount: 'vzb0066'
  }
}

// })();


export default {
  protocol,
  env: pathObj.env, // 当前环境 如yxvzb doc
  urlPath: '', //页面地址
  urlRoutePath: `${this.urlPath}/html/newWechat.html#/`,  // 页面路径
  javaPath:pathObj.javaPath, //接口地址
  wxAppId: pathObj.wxAppId, //微信APPID
  domainName: pathObj.domainName, //域名
  webSocketPath:pathObj.webSocketPath, //弹幕
  wxAccount: pathObj.wxAccount, //注册来源
  wxAuth: function (routePage) {
    // 授权转跳使用中转页面
    let r = encodeURIComponent(`http://cdn.yxvzb.com/WEB/transfer/index.html?vue_redirect_url=${routePage}`)
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxAppId}&redirect_uri=http%3a%2f%2f${this.domainName}%2frest%2fysh%2fwx%2fwxIndex%2fauthorizeCallback%3fredirectUri%3d${r}&response_type=code&scope=snsapi_userinfo&source_type=wx&state=3#wechat_redirect`
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js